import React from "react";
import PropTypes from "prop-types";
import authActions from "../../../redux/futures/auth/actions";
import _ from "lodash";
import { connect } from "react-redux";
import baseHelper from "../../../helpers/BaseHelper";
import appConst from "../../../config/const";
import queryString from "query-string";


import * as types from "../../../redux/futures/auth/types";
import i18n from "../../../i18n";

import LadiAppLogo from "../../../components/LadiAppLogo";
import ModalAuthenApplication from "./ModalAuthenApplication";
import ModalAuthenOTPCode from "./ModalAuthenOTPCode";
class ModalSelectMethod2FA extends React.Component {
  static propTypes = {
    code: PropTypes.string,
  };

  constructor(props) {
    super(props);

    const parsed = queryString.parse(this.props.location.search);

    let token = false;
    if (parsed.token && parsed.token != '') {
      token = parsed.token;
    }
    let is_verify_phone = false;
    if (parsed.is_verify_phone && parsed.is_verify_phone != '') {
      is_verify_phone = parsed.is_verify_phone;
    }
    let phone = false;
    if (parsed.phone && parsed.phone != '') {
      phone = parsed.phone;
    }


    this.state = {
      dataAuth: {},
      method: appConst.VERIFY_2FA_TYPE.TOTP.value,
      token,
      is_verify_phone,
      phone,
      search: this.props.location.search,
      loading: false,
      classNormal: "ladiui btn btn-primary full-width",
      classLoading: "ladiui loader btn btn-primary full-width",
      classApply: "ladiui btn btn-primary full-width",
    };
    this.inputsRef = new Set();
    this.ref = React.createRef();
  }
  componentDidMount() {

  }
  componentWillMount() {
    this.redirectAuth(this.props);
  }
  redirectAuth(props) {
    const tokenCookie = baseHelper.getCookie(appConst.LADI_UID_TOKEN);
    const { token } = this.state;
    if (!tokenCookie && !token) {
      props.history.push("/signin");
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.action == types.GENERATE_TOTP) {
      if (nextProps.status) {
        // const user = nextProps.data;
        console.log(' nextProps.data dataAuth = ', nextProps.data)
        this.setState({ dataAuth: nextProps.data });
        // window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
        window.LadiUI.showModal('modal-authen-application');
      } else {
        window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
      }
      this.setState({
        loading: false,
        classApply: this.state.classNormal,
      });
    }
    if (nextProps.action == types.VERIFY_AND_ENABLE_2FA) {
      if (nextProps.status) {
        // const user = nextProps.data;
        // window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
        window.LadiUI.closeModal('modal-authen-application');
      } else {
        window.LadiUI.showErrorMessage(i18n.t('BASE.NOTIFICATION'), nextProps.message, 'OK');
      }
      this.setState({
        loading: false,
        classApply: this.state.classNormal,
      });
    }

  }

  handleShowModalAuthen = (event) => {
    event.preventDefault();

    const { code, token } = this.state;
    const jsonData = {
      token: code,
      search: this.state.search,
      custom_auth: token
    };
    this.setState({ method: appConst.VERIFY_2FA_TYPE.TOTP.value });
    this.props.generateTOTP(jsonData);
    this.state.loading = true;
    this.state.classApply = this.state.classLoading;

  }
  handleShowModalAuthenOTP = (event) => {
    this.setState({ method: appConst.VERIFY_2FA_TYPE.SMS.value })
    window.LadiUI.showModal('modal-authen-otp');
  }


  componentWillUnmount() {

  }

  componentDidUpdate() {
    window.LadiUI.init();
  }

  activeAuth = (code) => {

    const { method, token } = this.state;
    const jsonData = {
      token: code,
      method,
      custom_auth: token
    };
    this.props.verifyAndEnable2FA(jsonData);
    this.state.loading = true;
    this.state.classApply = this.state.classLoading;
  };

  resendOtp2FA = (phone) => {

    const { token } = this.state;
    const jsonData = {
      custom_auth: token,
      phone
    };
    this.props.resendOtp2FA(jsonData);
    this.state.loading = true;
    this.state.classApply = this.state.classLoading;
  };

  onChangeInput = (event) => {
    this.setState({
      code: event.target.value,
    });
  };

  resendCode = () => {
    const { token, countDownTime } = this.state;
    if (countDownTime > 0) {
      return;
    }
    const jsonData = {

      custom_auth: token
    };
    this.props.resendOtp2FA(jsonData);
  }
  render() {
    const { dataAuth } = this.state;
    // console.log(email);
    const search = this.props.location.search;
    return (
      <div className="ladiui auth">

        <div className="ladiui-login-wrap no-frame">
          <LadiAppLogo />
          <h1 className="form-title" >{i18n.t('TWO_FA_AUTH.SELECT_METHOD_2FA')}</h1>
          <div className="ladiui-login" style={{ width: '480px' }}>
            <div className="ladiui-login-form create-user-form" >
              <div className="ladiui-form">
                <div className='list-methods'>
                  <div className='method-item' onClick={this.handleShowModalAuthen}>
                    {/* <i className="ladiui icon icon-menu-payment"></i> */}
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-key h-5 w-5 text-primary">
                      <path d="m15.5 7.5 2.3 2.3a1 1 0 0 0 1.4 0l2.1-2.1a1 1 0 0 0 0-1.4L19 4"></path><path d="m21 2-9.6 9.6"></path>
                      <circle cx="7.5" cy="15.5" r="5.5"></circle>
                    </svg>
                    <div className='text'>
                      <p>{i18n.t('TWO_FA_AUTH.APPLICATION_AUTH')}</p>
                      <span>{i18n.t('TWO_FA_AUTH.APPLICATION_AUTH_DESC')}</span>
                    </div>
                  </div>

                  {/* <div className='method-item' onClick={this.handleShowModalAuthenOTP}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                      stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-smartphone h-5 w-5 text-primary">
                      <rect width="14" height="20" x="5" y="2" rx="2" ry="2"></rect><path d="M12 18h.01"></path>
                    </svg>
                    <div className='text'>
                      <p>{i18n.t('TWO_FA_AUTH.SMS_AUTH')}</p>
                      <span>{i18n.t('TWO_FA_AUTH.SMS_AUTH_DESC')}</span>
                    </div>
                  </div> */}

                </div>

              </div>
            </div>
          </div>
          <ModalAuthenApplication
            handleCloseModal={() => { }}
            activeAuth={this.activeAuth}
            dataAuth={dataAuth}
          />
          <ModalAuthenOTPCode
            isShowModal={false}
            handleCloseModal={() => { window.LadiUI.closeModal('modal-authen-otp'); }}
            isVerifyPhone={this.state.is_verify_phone}
            selectedPhone={this.state.phone}
            resendOtp2FA={this.resendOtp2FA}
            activeAuth={this.activeAuth}
          />

        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    resendOtp2FA: (data) =>
      dispatch(authActions.resendOtp2FA(data)),
    generateTOTP: (data) =>
      dispatch(authActions.generateTOTP(data)),
    verifyAndEnable2FA: (data) =>
      dispatch(authActions.verifyAndEnable2FA(data)),
  };
};

const mapStateToProps = (state) => ({ ...state.auth });

export default connect(mapStateToProps, mapDispatchToProps)(ModalSelectMethod2FA);
